import React from 'react';
import PropTypes from 'prop-types';
import NavDropdown from 'components/Nav/NavDropdown/NavDropdown';
import classes from './NavB.module.scss';

const NavB = (props) => {
  const {
    header, searchPlaceholderText, nodes,
  } = props;

  return (
    <div className={classes.wrapper}>
      {header && <h2
        className={classes.header}
        dangerouslySetInnerHTML={{ __html: header }}
      />}
      <NavDropdown
        searchPlaceholderText={searchPlaceholderText}
        nodes={nodes}
      />
    </div>
  );
};

NavB.propTypes = {
  /**
   * Text displays at the top of the component
  */
  header: PropTypes.string,
  /**
   * Text that displays on the input element of the dropdown
  */
  searchPlaceholderText: PropTypes.string,
  /**
   * A list of links that display directly below the header
  */
  nodes: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    linkTarget: PropTypes.string,
    title: PropTypes.string,
  })),
};

export default NavB;
